import React__default, { Component } from 'react';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import InfoIcon$1 from './Icons/InfoIcon.js';

var css_248z = ".yCPgr{height:17px;vertical-align:text-bottom}[dir] .yCPgr{padding-top:2px}.yCPgr:hover{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}.fPH-F{display:flex}[dir] .fPH-F{cursor:pointer}";
var infoIconStyles = {"infoIcon":"yCPgr","infoContainer":"fPH-F"};
styleInject(css_248z);

class InfoIcon extends Component {
  render() {
    const {
      tooltipText,
      iconStyles,
      size: { height, width } = { height: 24, width: 24 },
      forceVisibility
    } = this.props;
    const style = iconStyles || infoIconStyles.infoIcon;
    return /* @__PURE__ */ React__default.createElement(Tooltip, { content: tooltipText, forceVisibility }, /* @__PURE__ */ React__default.createElement(InfoIcon$1, { className: style, height, width }));
  }
}

export { InfoIcon as I, infoIconStyles as i };
//# sourceMappingURL=InfoIcon-7460edb5.js.map
